export const createURLMapping = () => {
  return {
    auth: {
      login: () => "/login/customer",
      logout: () => "/logout",
    },
    register: {
      request: () => "/register/request",
      register: () => "/register/customer",
    },
    forgotPassword: {
      request: () => "/user/forgetPassword/request",
      confirm: () => "/user/forgetPassword/confirm",
    },
    user: {
      self: () => "/user/self",
    },
    order: {
      send: () => "/order"
    }
  };
};

export const ServiceURL = createURLMapping();
